import { copilotTeachingPopoverStore } from "owa-iris-store";
import type { MailboxInfo } from "owa-client-types";
import { initializeCopilotTeachingStore } from "./initializeCopilotTeachingStore";

export async function lightupPrecondition(anchorID: string, mailboxInfo: MailboxInfo): Promise<boolean> {
    await initializeCopilotTeachingStore(mailboxInfo);
    
    return (copilotTeachingPopoverStore().visible && anchorID === copilotTeachingPopoverStore().anchorID);
}
